   <!-- HEADER -->
    <div style="float:left;">
        <h2 mat-dialog-title><span translate>{{report.Description}}</span></h2>
    </div>
    <!-- CONTENT -->
    <mat-dialog-content>
        <table style="width:100%;" st-select-row="parameterRow" st-select-mode="single">
            <tr>
                <td>

                    <table>
                        <tr>
                            <td colspan="3" style="padding-top:5px;">
                                <tyl-form-field label="Report Title" style="width:350px;">
                                    <input matInput name="ReportTitle" id="ReportTitle"
                                        [(ngModel)]="reportParameter.ReportTitle" />
                                </tyl-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-top:5px;">
                                <tyl-datepicker label="Report Date" style="width:350px;" name="PrintDate" id="PrintDate"
                                    [(value)]="reportParameter.PrintDate">
                                </tyl-datepicker>
                            </td>
                        </tr>
                    </table>

                </td>
            <tr style="padding-left:10px; width:300px;" rowspan="4">
                <table>
                    <tr>
                        <td>
                            <tyl-checkbox [(checked)]="reportParameter.PrintAdds" id="chkPrintAdds" name="chkPrintAdds">
                                Print Address and Telephone on ADDs to Class
                            </tyl-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <tyl-checkbox [(checked)]="reportParameter.PrintComment" id="chkPrintComment"
                                name="chkPrintComment">
                                Print Attendance Comments
                            </tyl-checkbox>
                        </td>
                    </tr>
                </table>
            </tr>


            <!-- new -->
            <tr>
                <td>
                    <table style="border: 1px solid lightgray;margin-top:10px; align-items: flex-start;border-collapse: separate;">
                        <tr>
                            <td style="width:200px;align-items: flex-start; padding-left: 10px; padding-top: 17px" rowspan="4">
                                <table>

                                    <td>
                                        <tyl-datepicker label="Attendance Date" style="width:200px;"
                                            name="AttendanceDate" id="AttendanceDate"
                                            [(value)]="reportParameter.AttendanceDate">
                                        </tyl-datepicker>
                                    </td>

                                </table>
                            </td>
                            <td style="padding-left:3px;padding-top:5px;">
                                <!-- <select style="width:128px;"
                                data-ng-model="TeacherSummaryPreview.TermId"
                                ng-init="TeacherSummaryPreview.TermId=-1"
                                ng-options="result.Id as result.LongDescription for result in TeacherSummaryPreview.Terms|orderBy: 'LongDescription'">
                                </select> -->

                                <tyl-form-field label="Filter Classes">
                                    <mat-select name="FilterClasses"
                                        [(ngModel)]="selectedTerm"
                                        (ngModelChange)="changeTerm($event)">
                                        <mat-option
                                            *ngFor="let term of terms"
                                            [value]="term">
                                            {{term.LongDescription}}
                                        </mat-option>
                                    </mat-select>
                                </tyl-form-field>

                            </td>

                            <td style="padding-left:10px;align-items: flex-start">
                                <div style="padding-top:5px;">
                                    <tyl-form-field label="From Period" style="min-width:100px; max-width:100px">
                                        <input matInput #FromPeriod name="FromPeriod" id="FromPeriod"
                                            [(ngModel)]="reportParameter.FromPeriod" min='0' [textMask]="numberMask"
                                            style="text-align:right;width:100px;" (change)="changeValue()" />
                                    </tyl-form-field>
                                </div>
                            </td>
                            <td style="padding-left:10px;align-items: flex-start">
                                <div style="padding-top:5px;">
                                    <tyl-form-field label="To Period" style="min-width:100px; max-width:100px">
                                        <input matInput name="ToPeriod" #ToPeriod id="ToPeriod"
                                            [(ngModel)]="reportParameter.ToPeriod" min='0' [textMask]="numberMask"
                                            style="text-align:right;width:100px;" (change)="changeValue()" />
                                    </tyl-form-field>
                                </div>
                            </td>
                            <td style="padding-left:10px;padding-right:10px;align-items: flex-start">
                                <button mat-button style="color: white;background-color: #3f51b5;" (click)="refreshGrid()">
                                    Update Display
                                </button>
                            </td>
                        </tr>

                    </table>
                </td>
            </tr>
            <!-- Angular Material table definition -->
            <div style="display: flex;flex-direction: column;"
                [ngStyle]="{'overflow': isDataExist ? 'auto' :'hidden' }">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" style="width:100%;">
                    <ng-container matColumnDef="SelectAll">
                        <th mat-header-cell *matHeaderCellDef>
                            <tyl-checkbox [(checked)]="reportParameter.selectAllReportGridData" id="chkselectAll"
                                name="chkselectAll" (change)="selectAll(reportParameter.selectAllReportGridData)">
                            </tyl-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <tyl-checkbox [(checked)]="element.Select" #Select (change)="selectClass()" translate>
                            </tyl-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="AbbreviatedTitle">
                        <th mat-header-cell *matHeaderCellDef> Title </th>
                        <td mat-cell *matCellDef="let element">{{element.AbbreviatedTitle}}</td>
                    </ng-container>
                    <ng-container matColumnDef="TeacherName">
                        <th mat-header-cell *matHeaderCellDef> Teacher Name</th>
                        <td mat-cell *matCellDef="let element">{{element.TeacherName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Period">
                        <th mat-header-cell *matHeaderCellDef> Per </th>
                        <td mat-cell *matCellDef="let element">{{element.Period}}</td>
                    </ng-container>
                    <ng-container matColumnDef="TermCode">
                        <th mat-header-cell *matHeaderCellDef> Term </th>
                        <td mat-cell *matCellDef="let element">{{element.TermCode}}</td>
                    </ng-container>
                    <ng-container matColumnDef="DepartmentCode">
                        <th mat-header-cell *matHeaderCellDef> Dept </th>
                        <td mat-cell *matCellDef="let element">{{element.DepartmentCode}}</td>
                    </ng-container>
                    <ng-container matColumnDef="SubjectCode">
                        <th mat-header-cell *matHeaderCellDef> Subject </th>
                        <td mat-cell *matCellDef="let element">{{element.SubjectCode}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Section">
                        <th mat-header-cell *matHeaderCellDef>Sec</th>
                        <td mat-cell *matCellDef="let element">{{element.Section}}</td>
                    </ng-container>
                    <ng-container matColumnDef="RoomNumber">
                        <th mat-header-cell *matHeaderCellDef> Room</th>
                        <td mat-cell *matCellDef="let element">{{element.RoomNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="DaysGroupDescription">
                        <th mat-header-cell *matHeaderCellDef> Days</th>
                        <td mat-cell *matCellDef="let element">{{element.DaysGroupDescription}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="gridColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: gridColumns;"></tr>
                </table>
            </div>


        </table>
    </mat-dialog-content>
    <!-- Footer -->
    <mat-dialog-actions>
        <!-- Footer -->
        <div class="flex-footer-left" style="align-items: center; width: 30%">
        </div>
        <div class="flex-footer-right" style="align-items: center; width: 70%">
            <!-- ERROR PROMPT -->
            <error-prompt [errorList]="errors"></error-prompt>
            <!-- CANCEL -->
            <tyl-button style="float:right; color: black;" image="save.png" label="Run" (clickEvent)="runClick()">
            </tyl-button>
            <tyl-button style="float:right; color: black;" image="cancel.png" label="Cancel"
                (clickEvent)="cancelShowReportParameters()"></tyl-button>
        </div>
    </mat-dialog-actions>
